import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { ToggleValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryToggleFieldProps {
  node: ToggleValueDefinition;
}

export const ProductSummaryToggleField: FC<ProductSummaryToggleFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;
  const valueToDisplay = data ? 'Yes' : 'No';

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {<FormattedMessage id={`field.${valueToDisplay}` as IntlKey} defaultMessage={`${valueToDisplay}`} />}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryToggleField.displayName = 'ProductSummaryToggleField';
